module.exports = __webpack_public_path__ + "static/img/a1.2eea2256.webp";